import styled from 'styled-components'
import { media, colors } from 'styles'

const StyledApp = styled.div`
  display: flex;

  main {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    min-height: 100vh;
    flex: 1;
    padding: 2rem 3rem;
    padding-bottom: 0;
    max-width: 80%;
    .chat-closed & {
      max-width: calc(80% - 50px);
    }
    .chat-open & {
      max-width: calc(80% - 320px);
    }
    .inbox-conversation-open & {
      position: sticky;
      top: 0;
      max-height: 100vh;
    }
    ${media.desktop`
      .chat-on & {
        max-width: 80%;
      }
    `}
    ${media.mobile`
      .chat-on & {
        max-width: none;
      }
    `}
  }

  .header {
    width: 100%;
  }

  .split {
    display: flex;

    .half {
      flex: 1 0 40%;
    }
  }

  ${media.mobile`
    flex-direction: row-reverse;

    main {
      width: 100%;
      max-width: none;
      padding: 0.5rem 1rem;

      > header {
        margin: -0.5rem -1rem 0;
        padding: 0.5rem 6rem 0 1rem;
      }
    }
  `}
`

export const StyledFooter = styled.footer`
  display: flex;
  padding-top: 2rem;
  margin-top: auto;
  color: ${colors.textSecondary};

  .nav-link {
    text-decoration: none;
    margin-right: 1rem;
    padding: 1rem;
    color: ${colors.textSecondary};
    display: inline-block;
    opacity: 0.7;
    &:hover {
      opacity: 1;
    }
  }

  .powered-by {
    opacity: 0.7;
    margin-left: auto;
    text-transform: capitalize;
  }
  ${media.mobile`
    display: block;
    text-align: center;
    .chat-on & {
      padding-right: 3rem;
    }

    .powered-by {
      padding: 1rem;
    }
  `}
`

export default StyledApp
